(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["erw-faq-page"] && !Shopify.designMode) return;
  try {
    
/* Accordion + sidebar scrollspy.
   - Click a question → toggle (only one open at a time)
   - Sidebar nav highlights the section currently in view */
(function(){
  var roots = document.querySelectorAll('.erw-faq-page');
  roots.forEach(function(root){
    if (root.dataset.wired === '1') return;
    root.dataset.wired = '1';

    // Accordion
    root.querySelectorAll('.erw-faq-q').forEach(function(btn){
      btn.addEventListener('click', function(){
        var item = btn.closest('.erw-faq-item');
        var wasOpen = item.classList.contains('is-open');
        root.querySelectorAll('.erw-faq-item.is-open').forEach(function(o){
          o.classList.remove('is-open');
          var b = o.querySelector('.erw-faq-q');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Scrollspy — highlight active sidebar link
    var sections = root.querySelectorAll('.erw-faq-section');
    var navLinks = root.querySelectorAll('.erw-faq-nav a');
    if (!sections.length || !navLinks.length) return;
    function update(){
      var current = '';
      var offset = 120;
      sections.forEach(function(sec){
        if (window.scrollY >= sec.offsetTop - offset) current = sec.id;
      });
      navLinks.forEach(function(a){
        a.classList.toggle('is-active', a.getAttribute('href') === '#' + current);
      });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["erw-quote-form"] && !Shopify.designMode) return;
  try {
    
/* ERW B2B Quote form handler — Klaviyo identify + track event.
   Requires window._learnq from Klaviyo Onsite Tracking. */
(function(){
  /* Room-config pre-fill: when URL hash matches #quote-<slug>,
     pre-fill Project Details with the room context + scroll to form. */
  var ROOM_MAP = {
    'quote-sanctuary':      'The Sanctuary (Entry Configuration · 100–150 sq ft)',
    'quote-wellness-suite': 'The Wellness Suite (Mid Configuration · 200–300 sq ft)',
    'quote-estate':         'The Biohacking Estate (Premium Configuration · 400+ sq ft)'
  };
  function handleRoomHash() {
    var key = (window.location.hash || '').replace('#', '');
    if (!ROOM_MAP[key]) return;
    var textarea = document.querySelector('form[id^="erw-b2b-form-"] textarea[name="project_details"]');
    if (textarea && !textarea.value.trim()) {
      textarea.value = 'Interested in: ' + ROOM_MAP[key] + '. Please send the specification sheets for this configuration. ';
    }
    var anchor = document.getElementById('quote');
    if (anchor) {
      setTimeout(function(){ anchor.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 80);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleRoomHash);
  } else {
    handleRoomHash();
  }
  window.addEventListener('hashchange', handleRoomHash);

  function showFormError(form, message) {
    var err = form.querySelector('.erw-form-error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'erw-form-error';
      var submitBtn = form.querySelector('.erw-form-submit');
      if (submitBtn) {
        submitBtn.parentNode.insertBefore(err, submitBtn);
      } else {
        form.appendChild(err);
      }
    }
    err.textContent = message;
    err.style.display = 'block';
    err.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearFormError(form) {
    var err = form.querySelector('.erw-form-error');
    if (err) err.style.display = 'none';
  }

  var forms = document.querySelectorAll('form[id^="erw-b2b-form-"]');
  forms.forEach(function(form){
    if (form.dataset.wired === '1') return;
    form.dataset.wired = '1';

    form.addEventListener('submit', function(e){
      e.preventDefault();
      clearFormError(form);

      var data = {};
      new FormData(form).forEach(function(v, k){
        data[k] = (v || '').toString().trim();
      });
      if (!data.business_email) {
        showFormError(form, 'Please enter a business email.');
        return;
      }

      // Guard: don't destroy the form unless Klaviyo onsite tracking is loaded.
      if (!window._learnq || typeof window._learnq.push !== 'function') {
        showFormError(form, 'Submission service is still loading. Please try again in a few seconds, or email support@eliterecoverywellness.com.');
        if (window.console) console.warn('[ERW Quote Form] window._learnq is not available — Klaviyo Onsite Tracking may be disabled.');
        return;
      }

      try {
        window._learnq.push(['identify', {
          '$email': data.business_email,
          '$first_name': data.first_name || '',
          '$last_name': data.last_name || '',
          '$phone_number': data.phone || '',
          'Company': data.company_name || '',
          'Form Source': data.form_source,
          'Facility Type': data.facility_type || '',
          'Practice Type': data.practice_type || '',
          'Project Type': data.project_type || '',
          'Primary Interest': data.primary_interest || '',
          'Project Volume': data.project_volume || '',
          'Budget Range': data.budget_range || '',
          'Project Details': data.project_details || ''
        }]);
        window._learnq.push(['track', 'Submitted B2B Quote', {
          'Form Source': data.form_source,
          'Company': data.company_name || ''
        }]);
      } catch (err) {
        showFormError(form, 'Something went wrong submitting your inquiry. Please email support@eliterecoverywellness.com directly.');
        if (window.console) console.error('[ERW Quote Form] Klaviyo push failed', err);
        return;
      }

      var successTitle = form.dataset.successTitle || 'Thank you — your inquiry has been received.';
      var successBody  = form.dataset.successBody  || 'A commercial specialist will reach out within 1 business day.';
      form.outerHTML =
        '<div class="erw-form-success">' +
          '<div class="erw-form-success-title">' + successTitle + '</div>' +
          '<div class="erw-form-success-body">'  + successBody  + '</div>' +
        '</div>';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
